module.exports = __webpack_public_path__ + "./images/91b1eb17e8c8f00a15288bc6dfc722a9.webp";